<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FBMHD">Whoopie!</h1>
<p class="INTRO1">Whoopie pies are the latest craze to hit big stores and bijoux bakeries everywhere – little mounds of cakey goodness, sandwiched together with delicious, gooey fillings. While they have been around in the USA for a long time, the rest of the world is finally starting to catch on. Originating in Pennsylvania, folklore has it that Amish women would bake them as a dessert for their husbands’ and children’s lunchboxes and when they found these special treats they would shout ‘whoopie!’</p>
<p class="INTRO1S">Traditionally, whoopies are chocolate flavoured with a marshmallow cream filling, but the basic recipe can be easily adapted for a wide variety of other flavours and fillings by adding or changing a few ingredients.</p>
<p class="INTRO1S">When we were first asked to write a book about whoopie pies, we immediately scoured the internet for information and selflessly visited many major stores to buy and try them (Natalie even flew to New York in search of whoopies!). What struck us most profoundly was that all whoopies looked the same. Granted, they were baked in a variety of different flavours, but other than the odd dusting of sprinkles, or dab of fondant icing, none of them were decorated in any way. With our background in cake design and decoration, we felt that here was an opportunity to transfer our skills with cakes and cupcakes onto whoopie pies – and this book is the result.</p>
<p class="INTRO1S">As you will see from the creations that follow, whoopie pies don’t need to be the cupcake’s poor relation – they can shine every bit as much, and sometimes more so, as the domed shape of the whoopie lends itself beautifully to some projects, much more so than the flat iced cupcake.</p>
<p class="INTRO1S">We hope you have as much fun trying out the designs in this book as we did dreaming them up. Each project has a difficulty rating shown in little whoopies – start with the easy ones and move on to the more complex designs as your confidence grows. Happy decorating!</p>
<p class="INTRO1S">Jill and Natalie</p>
<p class="INTRO1S"><a href="http://www.thegreatlittlecakecompany.co.uk" target="_blank">www.thegreatlittlecakecompany.co.uk</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01.vue?6d170669